import React, { useState, useEffect } from 'react';
import { SidebarProvider } from '../../components/navigation/Sidebar';
import Sidebar from '../../components/navigation/Sidebar';
import QuickActions from '../../components/navigation/QuickActions';
import DateRangeSelector from '../../components/navigation/DateRangeSelector';
import Select from '../../components/ui/Select';
import Button from '../../components/ui/Button';

import EngagementMetricCard from './components/EngagementMetricCard';
import EngagementTimelineChart from './components/EngagementTimelineChart';
import TopPostsCarousel from './components/TopPostsCarousel';
import AudienceDemographics from './components/AudienceDemographics';
import SentimentAnalysis from './components/SentimentAnalysis';
import PostPerformanceTable from './components/PostPerformanceTable';
import PostPreviewModal from './components/PostPreviewModal';

const FacebookEngagementCenter = () => {
  const [selectedPage, setSelectedPage] = useState('main-page');
  const [selectedModal, setSelectedModal] = useState(null);
  const [lastUpdate, setLastUpdate] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setLastUpdate(new Date());
    }, 300000);

    return () => clearInterval(interval);
  }, []);

  const facebookPages = [
  { value: 'main-page', label: 'GymPlix Official Page' },
  { value: 'fitness-page', label: 'GymPlix Fitness Community' },
  { value: 'nutrition-page', label: 'GymPlix Nutrition Hub' }];


  const kpiMetrics = [
  {
    title: 'Page Reach',
    value: '847.2K',
    change: '+12.4%',
    changeType: 'positive',
    icon: 'Eye',
    iconColor: 'bg-primary',
    trend: [45, 52, 48, 65, 58, 72, 68, 75, 82, 78, 85, 92]
  },
  {
    title: 'Post Engagement Rate',
    value: '8.7%',
    change: '+2.1%',
    changeType: 'positive',
    icon: 'Heart',
    iconColor: 'bg-error',
    trend: [35, 42, 38, 55, 48, 62, 58, 65, 72, 68, 75, 82]
  },
  {
    title: 'Audience Growth',
    value: '+15.3K',
    change: '+18.6%',
    changeType: 'positive',
    icon: 'Users',
    iconColor: 'bg-success',
    trend: [25, 32, 28, 45, 38, 52, 48, 55, 62, 58, 65, 72]
  },
  {
    title: 'Avg Response Time',
    value: '12 min',
    change: '-8.2%',
    changeType: 'positive',
    icon: 'Clock',
    iconColor: 'bg-warning',
    trend: [85, 82, 78, 75, 72, 68, 65, 62, 58, 55, 52, 48]
  }];


  const timelineData = [
  { date: '11/19', engagement: 12500, reach: 85000, reactions: 8200, shares: 1450 },
  { date: '11/20', engagement: 15800, reach: 92000, reactions: 9800, shares: 1680 },
  { date: '11/21', engagement: 18200, reach: 105000, reactions: 11200, shares: 1920 },
  { date: '11/22', engagement: 14600, reach: 88000, reactions: 8900, shares: 1550 },
  { date: '11/23', engagement: 21500, reach: 125000, reactions: 13500, shares: 2280 },
  { date: '11/24', engagement: 19800, reach: 115000, reactions: 12200, shares: 2050 },
  { date: '11/25', engagement: 23400, reach: 138000, reactions: 14800, shares: 2520 },
  { date: '11/26', engagement: 25600, reach: 152000, reactions: 16200, shares: 2750 }];


  const topPosts = [
  {
    id: 1,
    type: 'Video',
    image: "https://images.unsplash.com/photo-1682531492515-43382acf04d3",
    imageAlt: 'Athletic woman performing intense deadlift exercise in modern gym with professional lighting and equipment',
    content: 'Transform your fitness journey with our new 12-week strength training program! Join thousands of members who have already achieved their goals. Limited spots available - sign up today!',
    reach: 152000,
    reactions: 16200,
    comments: 2840,
    shares: 2750,
    engagementRate: 14.3,
    date: '11/26/2025'
  },
  {
    id: 2,
    type: 'Image',
    image: "https://images.unsplash.com/photo-1656690099915-6d216495741c",
    imageAlt: 'Healthy meal prep containers with grilled chicken breast, quinoa, and colorful vegetables arranged on wooden table',
    content: 'Meal prep made easy! Check out our nutrition guide featuring 50+ healthy recipes designed by certified nutritionists. Download your free copy now and start eating better today.',
    reach: 138000,
    reactions: 14800,
    comments: 2320,
    shares: 2520,
    engagementRate: 13.8,
    date: '11/25/2025'
  },
  {
    id: 3,
    type: 'Carousel',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bf536866-1765854218598.png",
    imageAlt: 'Diverse group of fitness enthusiasts doing synchronized yoga poses in bright studio with natural lighting',
    content: 'Success stories that inspire! Meet Sarah, who lost 45 pounds and gained confidence through our personalized training program. Read her full journey and get motivated to start yours.',
    reach: 125000,
    reactions: 13500,
    comments: 2180,
    shares: 2280,
    engagementRate: 13.2,
    date: '11/23/2025'
  },
  {
    id: 4,
    type: 'Video',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_10e4efb22-1765794361939.png",
    imageAlt: 'Professional fitness trainer demonstrating proper squat form with detailed posture guidance in gym setting',
    content: 'Master the perfect squat form! Our certified trainers break down the technique step-by-step. Watch this essential tutorial and avoid common mistakes that could lead to injury.',
    reach: 115000,
    reactions: 12200,
    comments: 1950,
    shares: 2050,
    engagementRate: 12.8,
    date: '11/24/2025'
  },
  {
    id: 5,
    type: 'Image',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1da98edbd-1767543482923.png",
    imageAlt: 'Motivational fitness quote overlaid on image of determined athlete running up outdoor stairs at sunrise',
    content: 'Monday motivation: Your only limit is you! Start this week strong with our exclusive workout challenge. Tag a friend who needs to see this and let\'s crush our goals together!',
    reach: 105000,
    reactions: 11200,
    comments: 1820,
    shares: 1920,
    engagementRate: 12.1,
    date: '11/21/2025'
  }];


  const allPosts = [
  ...topPosts,
  {
    id: 6,
    type: 'Link',
    image: "https://images.unsplash.com/photo-1685633224860-7655234d9cd5",
    imageAlt: 'Modern gym interior with state-of-the-art cardio equipment and weight training area with professional lighting',
    content: 'New gym location opening soon! Be among the first 100 members to join and receive lifetime discount. Premium equipment, expert trainers, and community support await you.',
    reach: 92000,
    reactions: 9800,
    comments: 1580,
    shares: 1680,
    engagementRate: 11.4,
    date: '11/20/2025'
  },
  {
    id: 7,
    type: 'Video',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_10e3cd77c-1767133171249.png",
    imageAlt: 'Personal trainer conducting one-on-one session with client demonstrating proper dumbbell technique in gym',
    content: 'Meet our trainer of the month! Coach Mike shares his top 5 tips for building muscle mass effectively. Learn from 15 years of experience in just 3 minutes.',
    reach: 88000,
    reactions: 8900,
    comments: 1420,
    shares: 1550,
    engagementRate: 10.8,
    date: '11/22/2025'
  },
  {
    id: 8,
    type: 'Image',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_176175e26-1767634410942.png",
    imageAlt: 'Fitness tracker smartwatch displaying workout metrics on wrist of athlete during intense training session',
    content: 'Track your progress like a pro! Our new fitness app integrates with all major wearables. Download now and get 30 days premium features free. Available on iOS and Android.',
    reach: 85000,
    reactions: 8200,
    comments: 1320,
    shares: 1450,
    engagementRate: 10.2,
    date: '11/19/2025'
  },
  {
    id: 9,
    type: 'Carousel',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_159a50448-1767636094533.png",
    imageAlt: 'Before and after transformation photos showing remarkable fitness journey results over six months period',
    content: 'Transformation Tuesday! Check out these incredible 6-month results from our members. Your journey starts with a single step. Book your free consultation today!',
    reach: 78000,
    reactions: 7500,
    comments: 1180,
    shares: 1320,
    engagementRate: 9.8,
    date: '11/18/2025'
  },
  {
    id: 10,
    type: 'Video',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1925a022b-1764780648333.png",
    imageAlt: 'Group fitness class with energetic instructor leading high-intensity interval training in spacious studio',
    content: 'Join our virtual fitness classes! Live sessions every day with certified instructors. First week free for new members. Stream from anywhere, anytime.',
    reach: 72000,
    reactions: 6800,
    comments: 1050,
    shares: 1180,
    engagementRate: 9.2,
    date: '11/17/2025'
  }];


  const demographics = {
    age: [
    { name: '18-24', value: 2850, percentage: 18.5 },
    { name: '25-34', value: 5420, percentage: 35.2 },
    { name: '35-44', value: 4280, percentage: 27.8 },
    { name: '45-54', value: 2140, percentage: 13.9 },
    { name: '55+', value: 710, percentage: 4.6 }],

    gender: [
    { name: 'Female', percentage: 58 },
    { name: 'Male', percentage: 40 },
    { name: 'Other', percentage: 2 }],

    locations: [
    { name: 'United States', percentage: 42 },
    { name: 'United Kingdom', percentage: 18 },
    { name: 'Canada', percentage: 12 },
    { name: 'Australia', percentage: 10 },
    { name: 'Others', percentage: 18 }]

  };

  const sentimentData = {
    positive: 8420,
    neutral: 2180,
    negative: 650,
    score: 8.4,
    avgResponseTime: '12 min',
    trendingTopics: ['fitness', 'workout', 'nutrition', 'transformation', 'motivation']
  };

  const handlePostClick = (post) => {
    setSelectedModal(post);
  };

  return (
    <SidebarProvider>
      <div className="min-h-screen bg-background">
        <Sidebar />
        <QuickActions />
        
        <main className="main-content">
          <div className="mb-8">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
              <div>
                <h1 className="text-3xl font-bold text-foreground mb-2">Facebook Engagement Center</h1>
                <p className="text-muted-foreground">Comprehensive Facebook page performance monitoring and community insights</p>
              </div>
              
              <div className="flex items-center gap-3">
                <div className="flex items-center gap-2 px-3 py-2 bg-success/10 text-success rounded-lg">
                  <div className="w-2 h-2 rounded-full bg-success animate-pulse" />
                  <span className="text-sm font-medium">Live</span>
                </div>
                <span className="text-sm text-muted-foreground">
                  Last updated: {lastUpdate?.toLocaleTimeString()}
                </span>
              </div>
            </div>

            <div className="flex flex-col lg:flex-row gap-4 mb-6">
              <DateRangeSelector />
              
              <Select
                options={facebookPages}
                value={selectedPage}
                onChange={setSelectedPage}
                className="w-full lg:w-64" />


              <div className="flex gap-2 ml-auto">
                <Button variant="outline" iconName="Filter">
                  Filters
                </Button>
                <Button variant="outline" iconName="Download">
                  Export
                </Button>
                <Button variant="default" iconName="RefreshCw">
                  Refresh
                </Button>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mb-8">
            {kpiMetrics?.map((metric, index) =>
            <EngagementMetricCard key={index} {...metric} />
            )}
          </div>

          <div className="grid grid-cols-1 xl:grid-cols-3 gap-6 mb-8">
            <div className="xl:col-span-2">
              <EngagementTimelineChart data={timelineData} onFilterChange={() => {}} />
            </div>
            
            <div className="space-y-6">
              <TopPostsCarousel posts={topPosts} onPostClick={handlePostClick} />
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
            <AudienceDemographics demographics={demographics} />
            <SentimentAnalysis sentimentData={sentimentData} />
          </div>

          <PostPerformanceTable posts={allPosts} onPostClick={handlePostClick} />
        </main>

        <PostPreviewModal
          post={selectedModal}
          isOpen={!!selectedModal}
          onClose={() => setSelectedModal(null)} />

      </div>
    </SidebarProvider>);

};

export default FacebookEngagementCenter;